import React from "react";

function EditButton({
  pages,
  isSelected,
  setIsSelected,
  selected,
  setComponents,
}: any) {
  const handleSelect = () => {
    if (isSelected === pages.id) {
      setIsSelected();
    } else {
      setIsSelected(pages.id);
    }
    selectComponent();
  };

  const selectComponent = () => {
    setComponents(pages);
  };

  return (
    <button
      type="button"
      onClick={handleSelect}
      className={`my-1 flex h-[40px] min-w-[120px] items-center justify-center rounded-lg px-4 text-center text-sm font-medium transition-colors duration-200 max-sm:px-2 ${
        selected === true
          ? "bg-[#f30543]/10 text-[#f30543]"
          : "text-white/70 hover:bg-white/5 hover:text-white"
      }`}
    >
      {pages.name}
    </button>
  );
}

export default EditButton;